import { ApiService } from "@/api";

export const deleteBindUser = (sampleId: string) => {
  return ApiService.baseAction(`/sample/delete_user/${sampleId}`, {}, 'delete');
}